import React, {useEffect, useState} from "react";
import 'react-calendar/dist/Calendar.css';
import {Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";
import { Button, Typography, Grid } from '@material-ui/core';
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment-jalali";

const cardStyle={
	borderRadius:'25px',
	padding:'10px',
}

function PatientViewProfile(props) {

	const [patientID, setPatientID] = useState(Cookies.get('patientID'));
	const [data, setData] = useState([{}]);

	//api request for info
	useEffect(() => {
		// Fetch the sessions
		axios.get(`https://back.actelmon.ir/api/doctor/patient/${patientID}`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				setData(response.data)
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			});
	}, []);

	const englishToPersianNumbers = (input) => {
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		// Convert numbers in the input to Persian numbers
		const convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToSolarAndPersian = (gregorianDate) => {
		// Convert Gregorian date to Jalali (Solar) date
		if (!gregorianDate) gregorianDate = '2111-11-11'
		const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

		// Convert English numbers to Persian numbers
		const persianNumbers = englishToPersianNumbers(solarDate)
		//const persianNumbers = Persian(solarDate.toString()).englishNumber().persianNumber()._str;

		return persianNumbers;
	};

	const handleConfirm = () => {
		// send the new information to the server
		console.log('conf')
	};

	const [selectedFile, setSelectedFile] = useState(null);
	const [imagePreview, setImagePreview] = useState('F:/Business/thrita/thritacode/public/apple-icon.png');

	const handleFileChange = (e) => {
		const file = e.target.files[0];

		if (file && file.type.startsWith('image/')) {
			setSelectedFile(file);
			const reader = new FileReader();

			reader.onload = (e) => {
				setImagePreview(e.target.result);
			};

			reader.readAsDataURL(file);
		} else {
			setSelectedFile(null);
			setImagePreview(null);
			alert('Please select a valid image file.');
		}
	};

	//for download btn
	const [hovered, setHovered] = useState(false);
	const handleClickDownload = () => {
		// Replace this with your actual API response
		const fileUrl = data.medical_documents;

		// Create an invisible anchor element
		const link = document.createElement('a');
		link.href = fileUrl;
		link.download = 'your_file_name'; // Specify the desired file name
		link.target = '_blank';
		document.body.appendChild(link);

		// Trigger the click event on the anchor element
		link.click();

		// Remove the anchor element from the document
		document.body.removeChild(link);
	};

	return (
		<>
			<div className="content">
						<Row lg="12" sm="12" style={{backgroundColor:'white',padding:'30px',borderRadius:'10px'}}>

							<Col lg="9" sm="9">

								<Col lg="5" sm="5">

									<Card style={cardStyle} >
										<CardHeader className="text-right">
											<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات شخصی</CardTitle>
										</CardHeader>

										<CardBody>
											{/*birthDate*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
												<Grid item xs={5}>
													<Typography gutterBottom style={{color:'#757575'}}>
														تاریخ تولد
													</Typography>
												</Grid>
												<Grid item xs={7}>
													<Typography gutterBottom>
														{convertToSolarAndPersian(data.birth_date)}
													</Typography>
												</Grid>
											</Grid>
											{/*id*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
												<Grid item xs={5}>
													<Typography gutterBottom style={{color:'#757575'}}>
														کد شناسایی
													</Typography>
												</Grid>
												<Grid item xs={7}>
													<Typography gutterBottom>
														{englishToPersianNumbers(data.id ? data.id.toString() : '0')}
													</Typography>
												</Grid>
											</Grid>
											{/*insuranceTitle*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
												<Grid item xs={5}>
													<Typography gutterBottom style={{color:'#757575'}}>
														نام بیمه
													</Typography>
												</Grid>
												<Grid item xs={7}>
													<Typography gutterBottom>
														{data.insurance_company}
													</Typography>
												</Grid>
											</Grid>
											{/*insuranceNumber*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
												<Grid item xs={5}>
													<Typography gutterBottom style={{color:'#757575'}}>
														شماره بیمه
													</Typography>
												</Grid>
												<Grid item xs={7}>
													<Typography gutterBottom>
														{englishToPersianNumbers(data.insurance_number)}
													</Typography>
												</Grid>
											</Grid>
										</CardBody>
									</Card>

									<Card style={cardStyle} >
										<CardHeader className="text-right">
											<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات بیماری</CardTitle>
										</CardHeader>

										<CardBody>
											{/*diseaseBackground*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
												<Grid item xs={5}>
													<Typography gutterBottom style={{color:'#757575'}}>
														سابقه بیماری
													</Typography>
												</Grid>
												<Grid item xs={7}>
													<Typography gutterBottom>
														{data.injury_description}
													</Typography>
												</Grid>
											</Grid>
											{/*injuryType*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
												<Grid item xs={5}>
													<Typography gutterBottom style={{color:'#757575'}}>
														نوع آسیب
													</Typography>
												</Grid>
												<Grid item xs={7}>
													<Typography gutterBottom>
														{data.injury_type}
													</Typography>
												</Grid>
											</Grid>
											{/*sex*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
												<Grid item xs={5}>
													<Typography gutterBottom style={{color:'#757575'}}>
														مدارک پزشکی
													</Typography>
												</Grid>
												<Grid item xs={7}>
													<Typography
														gutterBottom
														style={{color: hovered ? '#EBAB60' : '#1073CF',
															textDecoration: 'none',
															cursor: 'pointer',
															transition: 'color 0.3s',}}
														//className={`${classes.link} ${hovered ? classes.hovered : ''}`}
														onMouseEnter={() => setHovered(true)}
														onMouseLeave={() => setHovered(false)}
														onClick={handleClickDownload}
													>
														دانلود
													</Typography>
												</Grid>
											</Grid>
										</CardBody>
									</Card>

								</Col>

								<Col lg="7" sm="7">
									<Card style={cardStyle} >
										<CardHeader className="text-right">
											<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات تماس</CardTitle>
										</CardHeader>

										<CardBody>
											{/*address*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
										<Grid item lg={2} xs={12}>
													<Typography gutterBottom style={{color:'#757575'}}>
														آدرس
													</Typography>
												</Grid>
										<Grid item lg={10} xs={12}>
													<Typography gutterBottom>
														{data.address}
													</Typography>
												</Grid>
											</Grid>
											{/*email*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
										<Grid item lg={2} xs={12}>
													<Typography gutterBottom style={{color:'#757575'}}>
														ایمیل
													</Typography>
												</Grid>
										<Grid item lg={10} xs={12}>
													<Typography gutterBottom>
														{data.email}
													</Typography>
												</Grid>
											</Grid>
											{/*phone*/}
											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
										<Grid item lg={2} xs={12}>
													<Typography gutterBottom style={{color:'#757575'}}>
														تلفن
													</Typography>
												</Grid>
										<Grid itemlg={10} xs={12}>
													<Typography gutterBottom>
														{englishToPersianNumbers(data.phone_number)}
													</Typography>
												</Grid>
											</Grid>



											{/*postalCode


											<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}}>
												<Grid item xs={2}>
													<Typography gutterBottom style={{color:'#757575'}}>
														کد پستی
													</Typography>
												</Grid>
												<Grid item xs={10}>
													<Typography gutterBottom>
														{postalCode}
													</Typography>
												</Grid>
											</Grid>


											*/}


										</CardBody>
									</Card>
								</Col>

							</Col>

							<Col lg="3" sm="3">

								<Card style={cardStyle} >
									<CardBody>
										<div className="logo"
										     style={{
											     width: '100%',
											     display: 'flex',
											     flexDirection: 'column',
											     alignItems: 'center',
											     textAlign: 'center'
										     }}>
											<Avatar
												alt={data.name}
												src={data.photo}
												sx={{
													width: 140,
													height: 140,
													backgroundColor: 'primary.main',
													margin: '0 auto',
													marginBottom: 2,
													marginTop: 2,
												}}
											/>
											<Typography variant="h5" component="div" sx={{ color:'#D0576E', fontWeight:'bold' }}>
												{data.name} {data.last_name}
											</Typography>

											{/*height*/}
											<Grid container spacing={2} style={{marginTop:'10px'}}>
												<Grid item xs={4}>
											<Typography gutterBottom  style={{ direction: 'rtl', textAlign: 'right', color: '#757575' }}>
														قد
													</Typography>
												</Grid>
												<Grid item xs={8}>
													<Typography gutterBottom>
														{englishToPersianNumbers(data.height ? data.height.toString() : '0')} سانتی متر
													</Typography>
												</Grid>
											</Grid>
											{/*weight*/}
											<Grid container spacing={2}>
												<Grid item xs={4}>
											<Typography gutterBottom  style={{ direction: 'rtl', textAlign: 'right', color: '#757575' }}>
														وزن
													</Typography>
												</Grid>
												<Grid item xs={8}>
													<Typography gutterBottom>
														{englishToPersianNumbers(data.weight ? data.weight.toString() : '0')} کیلوگرم
													</Typography>
												</Grid>
											</Grid>
											{/*blodType*/}
											<Grid container spacing={2}>
												<Grid item xs={4}>
											<Typography gutterBottom style={{ direction: 'rtl', textAlign: 'right', color: '#757575' }}>
														گروه خونی
													</Typography>
												</Grid>
												<Grid item xs={8}>
													<Typography gutterBottom>
														{data.blood_type}
													</Typography>
												</Grid>
											</Grid>

											<Button
												variant="outlined"
												fullWidth={true}
												style={{backgroundColor:'rgba(217,120,138,0.56)',color:'white' ,margin:'10px'}}
												onClick={() => props.viewInfo(false)}
											>
												بازگشت
											</Button>

										</div>

									</CardBody>
								</Card>

							</Col>

						</Row>
					</div>
		</>
	);
}

export default PatientViewProfile;
